const adalConfig = {
  tenant: window.ssoTenant || 'wartsila.onmicrosoft.com' || 'devct2directory.onmicrosoft.com',
  clientId: window.ssoClientId || '6626bad6-0c54-4046-868e-06b45db1845e' || 'b4e47dbc-8622-44f0-8fcc-7de4310aa6bd',
  extraQueryParameter: 'nux=1',
  disableRenewal: true,
  instance: 'https://login.microsoftonline.com/',
  endpoints: {
    [window.REST_URL || 'http://localhost:62065']: window.ssoClientId || '6626bad6-0c54-4046-868e-06b45db1845e' || 'b4e47dbc-8622-44f0-8fcc-7de4310aa6bd',
    'https://graph.microsoft.com': 'https://graph.microsoft.com'
  },
  postLogoutRedirectUri: window.ssoSignoutUrl || 'http://localhost:62065/signout',
  cacheLocation: 'localStorage', // enable this for IE, as sessionStorage does not work for localhost.
  anonymousEndpoints: []
};

module.exports = adalConfig;



// WEBPACK FOOTER //
// ./adal/adal-config.js